// This file is AUTOGENERATED, do not edit it manually!!!

export const portfolios = {
    add_portfolio: 'Ajouter un portefeuille',
    delete_portfolio_title: 'Supprimer le portefeuille {0} ?',
    DeletionIsUsedDisabled: 'Le statut ne peut pas être supprimé, car il existe un portefeuille avec ce statut.',
    Editor: 'Éditeur de portefeuille',
    Manager: 'Gestionnaire de portefeuille',
    members: '1#{0} membre du portefeuille#{0} membres du portefeuille',
    new_portfolio: 'Nouveau portefeuille',
    NewStatusTitle: 'Ajouter statut',
    permissions_title: 'Ce rôle dispose des autorisations suivantes en ce qui concerne le portefeuille et les projets qu\'il contient',
    Portfolios: 'Portefeuilles',
    role_for_this_portfolio: 'Rôle pour ce portefeuille :',
    Statuses: 'Statuts',
    Teamer: 'Participant au portefeuille',
    Viewer: 'Visionneur du portefeuille',
};
